import React from "react";
import DefectRouter from './Defect/Router';
export { getFields } from './Defect/Router';

export default function DefectSupervisorRouter(props){
    return <DefectRouter {...props} mode='SUPERVISOR' />;
}